var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightAlignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.84 6H11.92C11.832 6 11.76 6.08136 11.76 6.18079V7.44633C11.76 7.54576 11.832 7.62712 11.92 7.62712H21.84C21.928 7.62712 22 7.54576 22 7.44633V6.18079C22 6.08136 21.928 6 21.84 6ZM21.84 15.5819H11.92C11.832 15.5819 11.76 15.6633 11.76 15.7627V17.0282C11.76 17.1277 11.832 17.209 11.92 17.209H21.84C21.928 17.209 22 17.1277 22 17.0282V15.7627C22 15.6633 21.928 15.5819 21.84 15.5819ZM21.84 20.3729H6.16C6.072 20.3729 6 20.4542 6 20.5537V21.8192C6 21.9186 6.072 22 6.16 22H21.84C21.928 22 22 21.9186 22 21.8192V20.5537C22 20.4542 21.928 20.3729 21.84 20.3729ZM21.84 10.791H6.16C6.072 10.791 6 10.8723 6 10.9718V12.2373C6 12.3367 6.072 12.4181 6.16 12.4181H21.84C21.928 12.4181 22 12.3367 22 12.2373V10.9718C22 10.8723 21.928 10.791 21.84 10.791Z",
    fill: "#B4B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlignIcon);
export default __webpack_public_path__ + "static/media/RightAlignIcon.9d23dc296cb8189e91a52137119dfe9d.svg";
export { ForwardRef as ReactComponent };